import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import HomePage from './pages/HomePage';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';

// Filtre des props
const propFilter = (prop) => {
  const blacklist = [
    'scrolled', 'isLight', 'rotateX', 'rotateY',
    'elevation', 'delay', 'active', 'show', 'success'
  ];
  return isPropValid(prop) && !blacklist.includes(prop);
};

function App() {
  return (
    <StyleSheetManager shouldForwardProp={propFilter}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/:slug" element={<HomePage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        </Routes>
      </BrowserRouter>
    </StyleSheetManager>
  );
}

export default App;